import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import Home from "./pages/Home";
import CareerGuidance from "./pages/CareerGuidance";
import CareerPaths from "./pages/CareerPaths";
import CareerRoadmaps from "./pages/CareerRoadmaps";
import Resources from "./pages/Resources";
import About from "./pages/About";
import BookConsultation from "./pages/BookConsultation";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Start from "./pages/Start";
import Admin from "./pages/Admin";
import WhatsAppFloat from "./components/WhatsAppFloat";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white font-body text-ink">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career-guidance" element={<CareerGuidance />} />
          <Route path="/career-paths" element={<CareerPaths />} />
          <Route path="/career-roadmaps" element={<CareerRoadmaps />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/book-consultation" element={<BookConsultation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/start" element={<Start />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <MobileCTA />
        <WhatsAppFloat />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
